var map = {
	"./1-1.png": 8576,
	"./1-2.png": 9203,
	"./1-3.png": 8192,
	"./1-4.png": 5483,
	"./1-5.png": 2208,
	"./1-6.png": 6919,
	"./2-1.png": 7362,
	"./2-2.png": 2840,
	"./2-3.png": 6464,
	"./2-4.png": 6156,
	"./3-1.png": 3866,
	"./3-2.png": 9366,
	"./3-3.png": 5138,
	"./3-4.png": 6082,
	"./3-5.png": 7929,
	"./4-1.png": 1209,
	"./4-2.png": 8180,
	"./4-3.png": 9971,
	"./4-4.png": 3362,
	"./4-5.png": 7774,
	"./recommed1.png": 5261,
	"./recommed2.png": 2186,
	"./recommed3.png": 6306,
	"./recommed4.png": 396,
	"./recommed5.png": 5930,
	"./result1.png": 7788,
	"./result2.png": 5715,
	"./result3.png": 8438,
	"./result4.png": 9110,
	"./video1.png": 5637,
	"./video2.png": 8981,
	"./video3.png": 4125
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3145;